import { Box, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import { KeepsakeAlsoLove, KeepsakeHowItWorks } from 'artkive/pages/Keepsakes'
import theme from 'artkive/utils/theme'

export const HeroCta = styled(Box)(({ theme: { breakpoints } }) => ({
  marginTop: 62,
  [breakpoints.up('md')]: {
    marginTop: 36,
  },
}))

export const MosaicHowItWorks = styled(KeepsakeHowItWorks)({
  backgroundColor: theme.colors.white.dark,
})

export const FeaturesTitle = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    maxWidth: 440,
    margin: '0 auto',
  },
}))

export const FeaturesSprite = styled(Image)(({ theme: { breakpoints } }) => ({
  position: 'absolute',
  top: -50,
  right: -10,
  width: 64,
  transform: 'scaleX(-1)',
  zIndex: 1,
  [breakpoints.up('md')]: {
    top: -36,
    right: -40,
  },
}))

// On phones the dots stay at least 12px clear of the last card's title.
export const FeaturesBubbles = styled(Image)(({ theme: { breakpoints } }) => ({
  position: 'absolute',
  bottom: 109,
  left: -10,
  width: 80,
  transform: 'scaleX(-1)',
  zIndex: 0,
  [breakpoints.up('md')]: {
    top: 188,
    bottom: 'auto',
    left: -40,
    width: 72,
  },
  // Below 1280 the cards shrink and the first title reaches under the bubbles, so keep them 12px under the photo
  // (photo bottom = 25vw - 40px at these widths).
  [breakpoints.only('md')]: {
    top: 'calc(25vw - 166px)',
  },
}))

// Below 1080 the card's content margin narrows to 32px, so the arrow keeps the carousel's own offset there.
export const AlsoLove = withStyles(({ breakpoints }) => ({
  lines: {
    [breakpoints.up(1080)]: {
      right: -36,
    },
  },
}))(KeepsakeAlsoLove)
